import { render, staticRenderFns } from "./EditReturns.vue?vue&type=template&id=515c724c&scoped=true"
import script from "./EditReturns.vue?vue&type=script&lang=js"
export * from "./EditReturns.vue?vue&type=script&lang=js"
import style0 from "./EditReturns.vue?vue&type=style&index=0&id=515c724c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c724c",
  null
  
)

export default component.exports